import React from 'react';
import { useTranslation } from 'react-i18next';

import { TypingMode } from '@Api/models/TypingTestResultModel';

import Row from '@Components/atoms/Row';
import { RowGap } from '@Components/atoms/Row/Row';
import { PropsWithClassName } from '@Components/helper';

import { ModeSelectionButton } from './ModeSelection.styles';

interface Props extends PropsWithClassName {
  mode: TypingMode;
  updateMode: (value: TypingMode) => void;
}

const ModeSelection = (props: Props): React.ReactElement => {
  const { mode, updateMode } = props;
  const { t } = useTranslation('global');
  return (
    <Row noGutters className={props.className} dataTestId="ModeSelection-root" rowGap={RowGap.Small} xsEnd>
      <ModeSelectionButton active={mode === TypingMode.Normal} onClick={() => updateMode(TypingMode.Normal)}>
        {t('typing_test_mode.normal')}
      </ModeSelectionButton>
      <ModeSelectionButton active={mode === TypingMode.Advanced} onClick={() => updateMode(TypingMode.Advanced)}>
        {t('typing_test_mode.advanced')}
      </ModeSelectionButton>
    </Row>
  );
};

export default ModeSelection;
